import React from "react";
import chartImage from "../assets/images/webp/tokenomics-chart.webp";

const Tokenomics = () => {
  return (
    <div
      id="tokenomics"
      className="bg-tokenomics-bg bg-no-repeat bg-center lg:bg-100 bg_size_custom max-md:relative lg:mt-[380px] 2xl:mt-[202px]"
    >
      <div className="xl:max-w-[1820px] xl:px-12 px-5 container md:pb-[108px] sm:pb-16 pb-8 mx-auto xl:pt-[200px] lg:pt-[160px] md:pt-[120px] pt-24">
        <h2 className="text-white text-center xl:text-custom-10xl lg:text-7xl md:text-6xl sm:text-5xl text-custom-42 leading-100 [text-shadow:4px_4px_0px_#102282] relative z-20">
          Tokenomics
        </h2>
        <div className="md:relative">
          <div className=" w-full my-32 flex justify-center items-center">
            <div className="border-[3px] max-w-[1256px] mx-auto w-full border-dark-purple rounded-3xl xl:px-[102px] px-12 xl:py-[82px] py-8 shadow-lgPurpleShadow bg-pink-bg">
              <p className="2xl:text-custom-10xl xl:text-custom-8xl md:pt-0 sm:pt-96 pt-80 lg:text-custom-7xl md:text-custom-6xl text-custom-5xl font-normal leading-100 text-body-bg [text-shadow:4px_4px_0px_#040F4B]">
                1 billion
              </p>
              <p className="font-black lg:text-custom-5xl md:text-3xl sm:text-2xl text-xl text-white font-roboto leading-100">
                Total supply
              </p>

              <p className="2xl:text-custom-10xl xl:text-custom-8xl lg:text-custom-7xl md:text-custom-6xl text-custom-5xl font-normal leading-100 text-light-purple lg:pt-[90px] md:pt-[70px] sm:pt-12 pt-6 [text-shadow:4px_4px_0px_#040F4B]">
                0%
              </p>
              <p className="font-black lg:text-custom-5xl md:text-3xl sm:text-2xl text-xl text-white font-roboto leading-100">
                Buy/Sell Tax
              </p>
              <img
                src={chartImage}
                alt="chart-image"
                className="xl:w-[761px] lg:w-[661px] sm:w-[561px] w-[441px] xl:h-[761px] lg:h-[661px] sm:h-[561px] h-[441px] absolute 2xl:right-[5%] lg:right-[-8%] md:right-[-12%] xl:top-[-110px] lg:top-[-136px] md:top-[-100px] top-[150px] right-1/2  translate-x-1/2 object-cover md:translate-x-0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tokenomics;
